import { getStore } from 'app/state/storeRegistry'
import { setAgentConfig } from '../state/mapsSlice'
import { saveCurrentMap } from '../state/mapsSagas'
import { runAppSaga } from 'app/state/store'
import { AgentConfig } from '../agent-types'

export async function updateAgentConfig(config: AgentConfig): Promise<void> {
  const store = getStore()
  const currentMap = store.getState().maps.currentMap

  if (!currentMap) {
    throw new Error('No current map found')
  }

  store.dispatch(setAgentConfig(config))

  await runAppSaga(function* () {
    yield saveCurrentMap()
  })
}
